<cb-dialog>
    <form class="flex-col flex" #defaultInstallerForm="ngForm">
        @if (isEdit()) {
            <cb-display-value-new label="Trade Type" [value]="mappedItem?.tradeType?.label">
            </cb-display-value-new>
        }
        @if (isAdd()) {
            <cb-select
                [required]="true"
                name="selectedTradeTypeId"
                label="Trade Type"
                [(ngModel)]="selectedTradeTypeId"
                (change)="selectedTradeTypeChanged()"
                [options]="availableTrades"
            >
            </cb-select>
        }
        <cb-business-accounts-input-find-cards
            label="Business Account"
            [(ngModel)]="selectedSupplier"
            name="selectedSupplier"
            [text]="selectedSupplier?.tradingName"
            [disabled]="false"
            [required]="true"
            (change)="supplierChanged()"
        >
        </cb-business-accounts-input-find-cards>
        @if (invalidSupplier) {
            <div class="flex-row">
                <mat-card class="cb-error-card">
                    <mat-card-content>
                        No Installer contact has been set up for this business account and trade
                        type combination at this location.
                    </mat-card-content>
                </mat-card>
            </div>
        }
    </form>
    <div actions>
        <span class="flex"></span>
        <button
            mat-raised-button
            color="primary"
            (click)="save()"
            [disabled]="
                defaultInstallerForm.invalid || defaultInstallerForm.pristine || invalidSupplier
            "
        >
            Save
        </button>
        <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
